export const recallReportKeys = {
  all: ['recallReports'] as const,
  lists: () => [...recallReportKeys.all, 'list'] as const,
  list: (filters?: Record<string, string>) => [...recallReportKeys.lists(), filters ?? {}] as const,
  details: () => [...recallReportKeys.all, 'detail'] as const,
  detail: (id: number) => [...recallReportKeys.details(), id] as const,
} as const;
